export default "__VITE_ASSET__42e2620c__"